export const POSTER_BLANK = '/plus_frontend/assets/ico-fm-video.png';
export const IMAGE_BLANK = '/plus_frontend/assets/ico-fm-image.png';
